import type { AxiosResponse } from "axios";

import { validateValues } from "../../utils";

import api from "../../../../../api";
import type { CommandFormValues } from "../../types";
import { resetDeclarationApprovalSchema } from "./types";
import type { IUser } from "../../../../../types";

export const handleResetDeclarationApproval = async (
  user: IUser,
  values: CommandFormValues
): Promise<AxiosResponse> => {
  const { date, declarationType } = validateValues(
    values,
    resetDeclarationApprovalSchema
  );

  return await api.kontax.resetDeclarationApproval(
    user.id,
    date,
    declarationType
  );
};
